// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"radio-group_wrapper__WJZva","legend":"radio-group_legend__WsJ8s"};